import { Cell } from '@/shared/ui/primitives';
import type { FC } from 'react';

import type { PassType } from '@/types';
import { formatDuration } from '@/shared/lib/period';
import { TEST_ID_BUILDERS } from '@/testIds';

interface PassTemplateListItemProps {
  template: PassType;
  onEdit?: (template: PassType) => void;
  onSelect?: (template: PassType) => void;
}

export const PassTemplateListItem: FC<PassTemplateListItemProps> = ({
  template,
  onEdit,
  onSelect,
}) => {
  const formatCredits = (credits: number | null): string => {
    if (credits === null) return '∞';
    return credits.toString();
  };

  const handleCellClick = (): void => {
    if (onSelect) {
      onSelect(template);
    } else if (onEdit) {
      onEdit(template);
    }
  };

  const subtitle = `${formatDuration(template.duration)} • ${formatCredits(template.credits)} credits`;

  return (
    <Cell
      data-testid={TEST_ID_BUILDERS.passTemplateOption(template.name)}
      onClick={handleCellClick}
      subtitle={subtitle}
    >
      {template.name}
    </Cell>
  );
};
